import { SVGProps, FunctionComponent } from "react";

import {
  IntegrationProvider,
  ResourceTypesForIntegrationProvider,
} from "src/api/connectApi/types";
import { ConnectionTemplate } from "src/connections/types";
import { IntegrationResource } from "src/integrationNode/types";

type Icon = FunctionComponent<
  SVGProps<SVGSVGElement> & { title?: string | undefined }
>;

// those categories will create a grouping in the connections settings
export const GROUPING_CATEGORIES = ["provider", "territory"] as const;
export type GroupingCategory = (typeof GROUPING_CATEGORIES)[number];

// those categories provide display names for nested providers to avoid redundancy,
// e.g. "grouping_categories": [
//    {
//      "value": "Equifax",
//      "category": "provider"
//    },
//    {
//      "value": "US",
//      "category": "territory"
//    },
//    {
//      "value": "PayNet",
//      "category": "product"
//    }
//  ]
// display name would be PayNet among multiple Equifax services
export const CATEGORY_DISPLAY_NAME = ["usecase", "product"] as const;

export type ProviderTag = {
  value: string | string[];
  category: GroupingCategory | string;
};

type IntegrationProperty = {
  description: string;
  docsUrl?: string;
};

export type ResourceConfig = {
  externalLink: string | null; // Allow null for WIP integrations
  integrationResource: () => IntegrationResource;
  integrationProperties?: IntegrationProperty; // Optional to allow default
};

export type ConnectionConfig<T extends IntegrationProvider> = {
  icon: Icon;
  template: ConnectionTemplate<T>;
  description: string;
  name: string;
  grouping_categories?: ProviderTag[];
  resources: Record<ResourceTypesForIntegrationProvider<T>, ResourceConfig>;
};

export type ConnectionMap = {
  [P in IntegrationProvider]?: ConnectionConfig<P>;
};
